module.exports = __webpack_public_path__ + "static/media/vf_wdress_core.61f09960.svg";